import React, { useState, useRef } from 'react';

const API = process.env.REACT_APP_API_URL || 'https://tzone-web-backend-1-2ev5.onrender.com';
const PU_COLOR = '#193255';

export default function LABImport({ athleteId, athleteName, onClose, onSuccess }) {
  const [file, setFile]         = useState(null);
  const [dragging, setDragging] = useState(false);
  const [loading, setLoading]   = useState(false);
  const [result, setResult]     = useState(null);
  const [error, setError]       = useState('');
  const inputRef                = useRef();

  function handleFile(f) {
    if (!f) return;
    const ext = f.name.split('.').pop().toLowerCase();
    if (!['csv','xlsx','xls','fit'].includes(ext)) { setError('Solo se aceptan archivos CSV, XLSX, XLS o FIT'); return; }
    setFile(f); setError(''); setResult(null);
  }

  async function detectEndpoint(file) {
    if (file.name.endsWith('.fit')) return `${API}/api/lab/fit-bulk/${athleteId}`;
    if (file.name.endsWith('.csv')) {
      // Leer primeras lineas para detectar si es Garmin o TrainingPeaks
      const text = await file.slice(0, 500).text();
      if (text.includes('Tipo de actividad')) return `${API}/api/lab/garmin-csv/${athleteId}`;
    }
    return `${API}/api/lab/import/${athleteId}`;
  }

  async function handleUpload() {
    if (!file) return;
    setLoading(true); setError(''); setResult(null);
    const formData = new FormData();
    const fieldName = file.name.endsWith('.fit') ? 'files' : 'file';
    formData.append(fieldName, file);
    try {
      const token    = localStorage.getItem('token');
      const endpoint = await detectEndpoint(file);
      const res   = await fetch(endpoint, { method:'POST', headers:{ Authorization:`Bearer ${token}` }, body:formData });
      const data  = await res.json();
      if (!res.ok) throw new Error(data.message || 'Error al importar');
      setResult(data); setFile(null);
      if (onSuccess) onSuccess(data);
    } catch(err) { setError(err.message); }
    finally { setLoading(false); }
  }

  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,.5)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000 }}>
      <div style={{ background:'#fff', borderRadius:14, padding:28, width:'90%', maxWidth:440, boxShadow:'0 8px 32px rgba(0,0,0,.18)' }}>
        <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:20 }}>
          <div>
            <div style={{ fontSize:15, fontWeight:700, color:PU_COLOR }}>📥 Importar datos</div>
            <div style={{ fontSize:12, color:'#6b7280', marginTop:2 }}>{athleteName}</div>
          </div>
          <button onClick={onClose} style={{ background:'none', border:'none', fontSize:20, cursor:'pointer', color:'#9ca3af' }}>✕</button>
        </div>
        <div
          onDragOver={e=>{ e.preventDefault(); setDragging(true); }}
          onDragLeave={()=>setDragging(false)}
          onDrop={e=>{ e.preventDefault(); setDragging(false); handleFile(e.dataTransfer.files[0]); }}
          onClick={()=>inputRef.current?.click()}
          style={{ border:`2px dashed ${dragging?PU_COLOR:'#d1d5db'}`, borderRadius:10, padding:'28px 20px', textAlign:'center', cursor:'pointer', background:dragging?'#f0f4ff':'#f9fafb', marginBottom:16 }}
        >
          <input ref={inputRef} type="file" accept=".csv,.xlsx,.xls,.fit" style={{ display:'none' }} onChange={e=>handleFile(e.target.files[0])} />
          {file ? (
            <div>
              <div style={{ fontSize:28, marginBottom:6 }}>📊</div>
              <div style={{ fontSize:13, fontWeight:600, color:PU_COLOR }}>{file.name}</div>
              <div style={{ fontSize:11, color:'#9ca3af', marginTop:4 }}>{(file.size/1024).toFixed(1)} KB</div>
            </div>
          ) : (
            <div>
              <div style={{ fontSize:32, marginBottom:8 }}>📂</div>
              <div style={{ fontSize:13, fontWeight:600, color:'#374151' }}>Arrastrá o hacé click para seleccionar</div>
              <div style={{ fontSize:11, color:'#9ca3af', marginTop:6 }}>CSV · XLSX · XLS · FIT — hasta 50 MB</div>
            </div>
          )}
        </div>
        {error && <div style={{ background:'#fef2f2', border:'1px solid #fca5a5', borderRadius:8, padding:'10px 14px', marginBottom:14, fontSize:12, color:'#dc2626' }}>❌ {error}</div>}
        {result && (
          <div style={{ background:'#f0fdf4', border:'1px solid #86efac', borderRadius:8, padding:'12px 14px', marginBottom:14, fontSize:12, color:'#166534' }}>
            <div style={{ fontWeight:700, marginBottom:4 }}>✅ Importación exitosa</div>
            <div>Actividades importadas: <strong>{result.inserted}</strong></div>
            {result.dateRange?.from && <div style={{ marginTop:2 }}>{new Date(result.dateRange.from).toLocaleDateString('es-CL')} → {new Date(result.dateRange.to).toLocaleDateString('es-CL')}</div>}
          </div>
        )}
        <div style={{ display:'flex', gap:10 }}>
          <button onClick={handleUpload} disabled={!file||loading} style={{ flex:1, background:file&&!loading?PU_COLOR:'#e5e7eb', color:file&&!loading?'#fff':'#9ca3af', border:'none', borderRadius:8, padding:'10px 0', fontSize:13, fontWeight:600, cursor:file&&!loading?'pointer':'not-allowed', fontFamily:'inherit' }}>
            {loading ? '⏳ Importando...' : '📥 Importar'}
          </button>
          <button onClick={onClose} style={{ background:'#f3f4f6', color:'#374151', border:'none', borderRadius:8, padding:'10px 16px', fontSize:13, cursor:'pointer', fontFamily:'inherit' }}>
            {result ? 'Cerrar' : 'Cancelar'}
          </button>
        </div>
      </div>
    </div>
  );
}
